import React from 'react';
import { motion } from 'framer-motion';
import { Check, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
const benefits = ['Despertar con más energía.', 'Recuperar el enfoque y eliminar la niebla mental.', 'Mejorar la calidad de tu sueño (más profundo y continuo).', 'Reducir los bajones de energía por la tarde.', 'Volver a sentir vitalidad sin dietas extremas ni rutinas imposibles.'];
export function ProductIntro() {
  return <section className="py-16 md:py-24 bg-[#0d0d0d] relative overflow-hidden" data-id="element-162">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-cyan-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-163" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-164">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-165">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1 text-center lg:text-left" data-id="element-166">
            <div className="inline-flex items-center gap-2 text-cyan-400 font-bold mb-3 md:mb-4 tracking-wider uppercase text-xs md:text-sm" data-id="element-167">
              <Zap size={16} data-id="element-168" />
              <span data-id="element-169">La Solución Definitiva</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6" data-id="element-170">
              Longevidad Activa <span className="text-cyan-400" data-id="element-171">35+</span>
            </h2>

            <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8" data-id="element-172">
              Aquí es donde entra Longevidad Activa 35+. Es un PDF práctico y
              directo, diseñado para ayudarte a:
            </p>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10 text-left" data-id="element-173">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-174">
                  <div className="mt-0.5 bg-cyan-500/20 p-1 rounded-full shrink-0" data-id="element-175">
                    <Check className="text-cyan-400" size={14} data-id="element-176" />
                  </div>
                  <span className="text-sm md:text-lg text-gray-200" data-id="element-177">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <div className="flex justify-center lg:justify-start" data-id="element-178">
              <CTAButton showPrice={false} data-id="element-179">Obtener Acceso Inmediato</CTAButton>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2 flex justify-center relative" data-id="element-180">
            <div className="relative w-full max-w-[250px] md:max-w-md" data-id="element-181">
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/20 to-purple-500/20 blur-3xl rounded-full" data-id="element-182" />
              <img src="https://cdn.magicpatterns.com/uploads/8E9wobJo46Jd3gvNc4BkAk/heylloyd-generated-1769625652820.png" alt="Longevidad Activa 35+ Cover" className="relative z-10 w-full h-auto drop-shadow-[0_0_30px_rgba(0,212,255,0.15)] rounded-lg" data-id="element-183" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}